import { render, staticRenderFns } from "./MedecinDetailFpregradcreate.vue?vue&type=template&id=440a2e21&"
import script from "./MedecinDetailFpregradcreate.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailFpregradcreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports